import { createContext, PropsWithChildren, useContext, useState } from 'react'

interface TrainingFormContextProps {
  isCreateTrainingModalOpen: boolean
  setIsCreateTrainingModalOpen: (isOpen: boolean) => void
}
const TrainingFormContext = createContext<TrainingFormContextProps | null>(null)

export const TrainingFormProvider = ({ children }: PropsWithChildren) => {
  const [isCreateTrainingModalOpen, setIsCreateTrainingModalOpen] =
    useState(false)

  return (
    <TrainingFormContext.Provider
      value={{ isCreateTrainingModalOpen, setIsCreateTrainingModalOpen }}
    >
      {children}
    </TrainingFormContext.Provider>
  )
}

export const useTrainingFormContext = () => {
  const context = useContext(TrainingFormContext)

  if (!context) {
    throw new Error(
      'useTrainingForm must be used within a TrainingFormProvider',
    )
  }

  return context
}
